"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(importantVal, selector) {
  return `${importantVal} ${selector}`;
}